import Paid from "@mui/icons-material/Paid";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import React, { SyntheticEvent } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { WPPost } from "../../../constants/types";
import {
    CostOfService,
    getCopyForCostOfService,
    getCopyForReferralOption,
    ListingAcf,
    ReferralOption,
} from "../../../constants/types/acf";
import { buttonResetStyles, getWpPostUrl } from "../../../utils";
import { useCommunitySpecificBlurb } from "../../../utils/community-context";
import { useListingDistance } from "../../../utils/hooks";
import { CardHeader } from "../../atoms/CardHeader";
import { SaveItemButton } from "../../atoms/SaveItemButton";
import { useListingModal } from "../../organisms/ListingItemModal/controller";
import { DevModeListingTaxonomies } from "./DevModeListingTaxonomies";
import {
    Outer,
    Content,
    Distance,
    Blurb,
    Tags,
    Tag,
    Bottom,
    FeaturedTag,
    Title,
} from "./styled";
interface Props {
    listing: WPPost<ListingAcf>;
    compact: boolean;
}

const HeaderButton = styled(Link)`
    ${buttonResetStyles};
`;

const HeaderContainer = styled.div`
    position: relative;
    .save-item{
        position: absolute !important;
        bottom: -22px;
        right: 1rem;
    }
`;

export const ListingCard: React.FC<Props> = ({ listing, compact }) => {
    const { openListing } = useListingModal();
    const blurb = useCommunitySpecificBlurb(listing) ?? listing.acf.meta.blurb;
    const distanceString = useListingDistance(listing);
    const compactClass = compact ? 'isCompact' : '';

    const { referral, cost_of_service } = listing.acf.meta;
    const listing_type = listing.acf.location_toggle;

    const handleOpenListing = (event: SyntheticEvent<HTMLElement>) => {
        event.preventDefault();
        openListing(listing);
    };

    return (
        <Outer className={compactClass}>
            <HeaderButton onClick={handleOpenListing} to={getWpPostUrl(listing)}>
                <HeaderContainer>
                    <CardHeader
                        backgroundColor={listing.acf.meta.logo_background_colour}
                        imageUrl={listing.acf.meta.logo.sizes?.medium ?? ""}
                    />
                    <SaveItemButton id={listing.id} />
                </HeaderContainer>
                <Content>
                    {listing.acf.meta.featured && (
                        <FeaturedTag>
                            {/* <div>Featured</div> */}
                        </FeaturedTag>
                    )}
                    <Title to={getWpPostUrl(listing)} onClick={handleOpenListing}>
                        {listing.title.rendered.length > 42 ?
                            `${listing.title.rendered.substring(0, 42)}...` : listing.title.rendered
                        }
                    </Title>

                    {distanceString && listing_type != 'digital' && <Distance>{distanceString}</Distance>}
                    <Blurb>{blurb}</Blurb>
                    <Bottom>
                        <DevModeListingTaxonomies listing={listing} />
                        {listing_type != 'digital' ?
                            <Tags>
                                {cost_of_service !== CostOfService.NotApplicable && (
                                    <Tag>
                                        <Paid />
                                        {getCopyForCostOfService(cost_of_service)}
                                    </Tag>
                                )}
                                {referral !== ReferralOption.NotApplicable && (
                                    <Tag>
                                        <PeopleRoundedIcon />
                                        {getCopyForReferralOption(referral)}
                                    </Tag>
                                )}
                            </Tags>
                            : ''
                        }
                    </Bottom>
                </Content>
            </HeaderButton>
        </Outer>
    );
};
